import React from "react";
import * as styles from "./Divider.module.css";

export interface DividerProps {
  margin?: string;
  borderColor?: string;
  className?: string;
  "aria-hidden"?: boolean;
}

/**
 * セクション間の区切りに使用
 * デフォルトではmarginを16px 0に設定している
 */
const Divider: React.FC<DividerProps> = ({
  margin = '16px 0',
  borderColor = '#D9D9D9',
  className,
  "aria-hidden": ariaHidden = true
}) => {
  const inlineStyle = {
    margin,
    borderColor: borderColor || '#D9D9D9',
  };

  return (
    <hr
      className={`${styles.divider} ${className || ''}`}
      style={inlineStyle}
      aria-hidden={ariaHidden}
    />
  );
};

export default Divider;
